module.exports = __webpack_public_path__ + "media/images/page/kodawari01-d769acca67dc9308d65a8d9ed947fde8.jpg";